import React from 'react';
import { AlertsDashboard } from '@/components/alerts/AlertsDashboard';

const AlertsPage: React.FC = () => {
  return <AlertsDashboard />;
};

export default AlertsPage;